import './DisplaySettings.css';
import * as VPAIDEvents from 'Enum/VPAIDEvents';
import * as ad from 'Services/Misc/ad';
import { h, render, Component } from 'preact';
import RootControl from './Components/RootControl';

export default class DisplayManager {
  onUpdate(nextState, prevState, changes) {
    this.state = nextState;

    if(ad.isShutdown(nextState)) {
      try {
        this.cleanup();
      } catch(e) {
        console.warn('problem destroying overlay container');
      }
      return;
    }

    if(changes.display.container) {
      this.container = nextState.display.container;
      render(<RootControl state={ this.state } changes={ changes } />, this.container);
      this.root = this.container.querySelector('#aa-video-ad-unit');
      this.addStyleSheets(this.root);
    }

    if(this.canRender(changes)) {
      render(<RootControl state={ this.state } changes={ changes } />, this.container, this.root);
    }
  }

  canRender(changes) {
    return (
      changes.media.current_time ||
      changes.display.shares     ||
      changes.display.hover      ||
      changes.media.complete     ||
      changes.media.paused       ||
      changes.media.started
    );
  }

  // In some cases, our Javascript executes in a different document than the container's document
  // We need to ensure the style sheets are included with the presentation elements 
  addStyleSheets(container) {
    Array.from(document.querySelectorAll('style[data-owner="aa"]')).forEach(tag => container.appendChild(tag));
  }

  cleanup() {
    this.root &&
    this.container &&
    this.container.removeChild &&
    this.container.hasChildNodes() &&
    this.root.parentNode === this.container &&
    this.container.removeChild(this.root);
  }
}


// WEBPACK FOOTER //
// ./src/Display/DisplayManager.js